import { render } from "./ClassicMenu.vue?vue&type=template&id=68848c23&scoped=true"
import script from "./ClassicMenu.vue?vue&type=script&lang=js"
export * from "./ClassicMenu.vue?vue&type=script&lang=js"

import "./ClassicMenu.vue?vue&type=style&index=0&id=68848c23&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68848c23"]])

export default __exports__